import { config } from '@/config';

// chat-service возвращает roomId как ЛОКАЛПАРТ (например `!abc`), а matrix-js-sdk оперирует полным
// id `!abc:server`. Эти утилиты приводят одно к другому, используя host из matrixServerUrl.

/** Хост homeserver (server_name) из URL Matrix: `https://matrix-dev.data1861.ru` → `matrix-dev.data1861.ru`. */
export function serverNameFromUrl(matrixUrl: string = config.matrixServerUrl): string {
  try {
    return new URL(matrixUrl).host;
  } catch {
    return matrixUrl.replace(/^https?:\/\//, '').replace(/\/.*$/, '');
  }
}

/** Дополнить локалпарт доменом сервера. Если id уже полный (содержит `:`) — вернуть как есть. */
export function toFullRoomId(roomIdOrLocalpart: string, matrixUrl: string = config.matrixServerUrl): string {
  if (roomIdOrLocalpart.includes(':')) {
    return roomIdOrLocalpart;
  }
  return `${roomIdOrLocalpart}:${serverNameFromUrl(matrixUrl)}`;
}

/** Компактная часть room id для URL: `!abc:server`/`!abc` → `abc` (без `!` и без сервера). */
export function roomIdToParam(roomId: string): string {
  return roomId.replace(/^!/, '').split(':')[0] ?? '';
}
